import React from 'react';

import {FIND_ALL_MODALIDADES as query} from '../../../graphql/queries';
import {SelectBase} from './select-apollo';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'descricao', sortDir: 'ASC'},
    searchDTO: {search},
  };
};

export const SelectModalidades = (props) => {
  return (
    <SelectBase
      responseObjectName="modalidades"
      labelProp="descricao"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};
